import api from '../../utils/api';
import { alertError } from './alert';

import {
  SET_CURRENT_FILTER_RANGE,
  STATS_TOTALS,
  STATS_BRANDS,
  STATS_REPLENISH,
  STATS_BRANDS_LOADING,
} from '../constants/statsTypes';

import {
  ORDER_TYPE_ECOMMERCE,
  ORDER_TYPE_DROPSHIP,
  ORDER_TYPE_MARKETPLACE,
  ORDER_TYPE_REORDER,
  ORDER_TYPE_REPLENISH,
} from '../../constants/orderTypes';

export const setStatsBrandsLoading = (value) => ({ type: STATS_BRANDS_LOADING, payload: value });
export const setStatsBrands = (data) => ({ type: STATS_BRANDS, payload: data });
export const setStatsReplenish = (data) => ({ type: STATS_REPLENISH, payload: data });
export const setStatsFilterRange = (startDate, endDate) => ({
  type: SET_CURRENT_FILTER_RANGE,
  payload: {
    start: new Date(startDate),
    end: new Date(endDate),
  },
});

export const setStatsTotals = (totalIncome, totalItems, totalOrders) => ({
  type: STATS_TOTALS,
  payload: { totalIncome, totalItems, totalOrders },
});

export const getStats = (startDate, endDate, retailerId) => async (dispatch, getState) => {
  try {
    dispatch(setStatsBrandsLoading(true));
    dispatch(setStatsFilterRange(startDate, endDate));

    const state = getState();
    const { supplierId } = state.role;

    let filter = {
      created_at: { $between: [startDate, endDate] },
    };

    if (retailerId) {
      filter = {
        ...filter,
        retailer_id: { $eq: retailerId },
      };
    }

    const brands = await stats(
      supplierId,
      JSON.stringify({
        ...filter,
        type: { $in: [ORDER_TYPE_ECOMMERCE, ORDER_TYPE_DROPSHIP, ORDER_TYPE_MARKETPLACE] },
      }),
    );
    const replenish = await stats(
      supplierId,
      JSON.stringify({
        ...filter,
        type: { $in: [ORDER_TYPE_REPLENISH, ORDER_TYPE_REORDER] },
      }),
    );

    dispatch(setStatsBrands(brands.data));
    dispatch(setStatsReplenish(replenish.data));
    let totalIncome = 0;
    let totalItems = 0;
    let totalOrders = 0;

    brands.data.forEach((value) => {
      totalIncome += +value.total_income;
      totalItems += +value.total_items;
      totalOrders += +value.total_orders;
    });

    replenish.data.forEach((value) => {
      totalIncome += +value.total_income;
      totalItems += +value.total_items;
      totalOrders += +value.total_orders;
    });

    dispatch(setStatsTotals(totalIncome / 100, totalItems, totalOrders));
    dispatch(setStatsBrandsLoading(false));
  } catch (error) {
    dispatch(alertError(error));
  }
};

const stats = (supplierId, filter) => {
  return api.get(`/suppliers/${supplierId}/order-stats?filter=${filter}`);
};
